/**
 * 使用:
 * this.$downloadingLayer.show({ content, iconclass })
 * this.$downloadingLayer.hide({})
 */
import { commonLoading } from '@/components'

let showDownloading = {}
let showDownloadingIns

// eslint-disable-next-line space-before-function-paren
showDownloading.install = function (Vue) {
  const LoadingConstructor = Vue.extend(commonLoading)

  Vue.prototype.$downloadingLayer = {
    show: ({ content = '', iconclass = '' }) => {
      if (!showDownloadingIns) {
        showDownloadingIns = new LoadingConstructor({
          el: document.createElement('div')
        })
        document.body.appendChild(showDownloadingIns.$el)
      }
      showDownloadingIns.content = content
      showDownloadingIns.iconclass = iconclass
    },
    hide: () => {
      if (showDownloadingIns) {
        showDownloadingIns.$destroy()
        document.body.removeChild(showDownloadingIns.$el)
        showDownloadingIns = null
      }
    }
  }
}

export default showDownloading
